import gql from "graphql-tag";

export const MY_NEWS_GET_LIST = gql`
  query getMyNewsList($page: Int!, $pageSize: Int!, $archived: Boolean) {
    getMyNewsList(page: $page, pageSize: $pageSize, archived: $archived) {
      page
      pageSize
      total
      totalPages
      rows {
        _id
        title
        description
        content
        priority
        createdAt
        createdBy
        publishedAt
        read
        editorEmployeeCode
        editorName
        modifiedAt
        modifiedBy
      }
    }
  }
`;
